import { type Theme } from '../../../../_shared/themes/theme.model';

export const ISOLATE_BOUNDARY_THEME_COLOR = 'theme';

export const getIsolateBoundaryColorHex = (theme: Theme, color: string): string => {
  return color === ISOLATE_BOUNDARY_THEME_COLOR ? theme.backgroundColors.secondary : color;
};
